export enum SignUpSteps {
  USERNAME = 'username',
  VERIFY_CODE = 'verifycode',
}
